import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { WA_NUMBER, BRANDS } from '../data/products';
interface NavbarProps {
  onBrandFilter?: (brand: string | null) => void;
}
export function Navbar({
  onBrandFilter
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isBrandsOpen, setIsBrandsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setIsBrandsOpen(false);
  };
  const handleBrandClick = (brand: string) => {
    if (onBrandFilter) {
      onBrandFilter(brand);
    }
    closeMenu();
    // Smooth scroll to products section
    setTimeout(() => {
      const productsSection = document.getElementById('productos');
      if (productsSection) {
        productsSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  const navLinks = [{
    href: '#productos',
    label: 'Productos'
  }, {
    href: '#nosotros',
    label: 'Nosotros'
  }, {
    href: '#faq',
    label: 'FAQ'
  }, {
    href: '#envios',
    label: 'Envíos'
  }, {
    href: '#ubicacion',
    label: 'Ubicación'
  }, {
    href: `https://wa.me/${WA_NUMBER}`,
    label: 'WhatsApp',
    external: true
  }];
  return <nav className="bg-dark-700 border-b-2 border-alphaGold py-4 px-5 relative z-50" data-id="element-174" data-mp="okp3aivyaf57">
      <div className="max-w-[1100px] mx-auto flex justify-between items-center" data-id="element-175" data-mp="3n45gd84xpyeb">
        <a href="#" className="flex items-center" onClick={closeMenu} data-id="element-176" data-mp="3s27aqp7t9k53">
          <img src="https://cdn.magicpatterns.com/uploads/o9QuWRFj9QDHop4MmMKe7L/Logo_-_Editado.png" alt="AlphaFit" className="h-8 md:h-10 object-contain" onError={e => {
          // Fallback to text if logo is missing
          e.currentTarget.style.display = 'none';
          e.currentTarget.nextElementSibling?.classList.remove('hidden');
        }} data-id="element-177" data-mp="3s0cqze89zy2l" />
          <span className="hidden text-2xl font-black text-alphaGold tracking-[3px] uppercase" data-id="element-178" data-mp="31azzefib64py">
            Alpha<span className="text-white" data-id="element-179" data-mp="2wcq6ycnyxi81">Fit</span>
          </span>
        </a>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-6 list-none" data-id="element-180" data-mp="3b1ckc8u1bzwm">
          <li data-id="element-181" data-mp="361zz1sitb0w5">
            <a href="#ofertas" className="inline-flex items-center gap-1.5 bg-[#ff3b30] text-white no-underline text-[0.85rem] font-black tracking-wide uppercase px-3.5 py-1.5 rounded-full transition-all duration-300 hover:bg-[#e0271d] hover:scale-105 shadow-[0_0_15px_rgba(255,59,48,0.4)] animate-pulse" data-id="element-182" data-mp="3629n3akaqxz7">
              ¡Ofertas!
            </a>
          </li>
          <li data-id="element-183" data-mp="2naz21a195ff8">
            <a href="#productos" onClick={() => onBrandFilter && onBrandFilter(null)} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-184" data-mp="2nb8quuak9gjc">
              Productos
            </a>
          </li>

          {/* Marcas Dropdown Desktop */}
          <li className="relative group" data-id="element-185" data-mp="f3lp5b7um62o">
            <button className="flex items-center gap-1 text-[#ddd] text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-186" data-mp="f5gfj51w2qe5">
              Marcas{' '}
              <ChevronDown size={16} className="transition-transform group-hover:rotate-180" data-id="element-187" data-mp="567l6b3439r9" />
            </button>
            <div className="absolute top-full left-0 w-56 bg-dark-700 border border-dark-500 rounded-md shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 translate-y-2 group-hover:translate-y-0 overflow-hidden" data-id="element-188" data-mp="xumow1gsm5na">
              {BRANDS.map(brand => <button key={brand} onClick={() => handleBrandClick(brand)} className="w-full text-left px-4 py-3 text-white hover:bg-dark-600 hover:text-alphaGold transition-colors border-b border-dark-500 last:border-0 font-medium" data-id="element-189" data-mp="1btw2ctdm6lnk">
                  {brand}
                </button>)}
            </div>
          </li>

          {navLinks.slice(1).map(link => <li key={link.label} data-id="element-190" data-mp="3f5klgdee8oi2">
              <a href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-191" data-mp="3b2nv20im3o3k">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-192" data-mp="3tz78h20g7y5x">
          {isOpen ? <X size={28} data-id="element-193" data-mp="pl8rbm4hmq00" /> : <Menu size={28} data-id="element-194" data-mp="pkpc4d682fpo" />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && <div className="md:hidden absolute top-full left-0 w-full bg-dark-700 border-b border-dark-400 shadow-xl py-4 px-5 flex flex-col gap-2" data-id="element-195" data-mp="28bwkue84d2be">
          <a href="#ofertas" onClick={closeMenu} className="text-white no-underline text-lg font-black tracking-wide uppercase bg-[#ff3b30] text-center py-2.5 rounded-lg mb-1 shadow-[0_0_15px_rgba(255,59,48,0.4)] hover:bg-[#e0271d] transition-colors" data-id="element-196" data-mp="2h96u5u1dmhdo">
            ¡Ofertas Imperdibles!
          </a>
          <a href="#productos" onClick={e => {
        if (onBrandFilter) onBrandFilter(null);
        closeMenu();
      }} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500" data-id="element-197" data-mp="2w560az4xe7g6">
            Productos
          </a>

          {/* Marcas Accordion Mobile */}
          <div className="border-b border-dark-500" data-id="element-198" data-mp="1euzb8z1o07da">
            <button onClick={() => setIsBrandsOpen(!isBrandsOpen)} className="w-full flex items-center justify-between text-[#ddd] text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-199" data-mp="1eto913nvb7oa">
              Marcas
              <ChevronDown size={20} className={`transition-transform duration-300 ${isBrandsOpen ? 'rotate-180' : ''}`} data-id="element-200" data-mp="1jsr2dquhjpgf" />
            </button>

            <div className={`overflow-hidden transition-all duration-300 ${isBrandsOpen ? 'max-h-80 opacity-100 mb-2' : 'max-h-0 opacity-0'}`} data-id="element-201" data-mp="1tkdhvzduwaoz">
              {BRANDS.map(brand => <button key={brand} onClick={() => handleBrandClick(brand)} className="w-full text-left pl-4 py-2 text-[#aaa] hover:text-alphaGold transition-colors text-base font-medium" data-id="element-202" data-mp="22jijjekpsk5d">
                  • {brand}
                </button>)}
            </div>
          </div>

          {navLinks.slice(1).map(link => <a key={link.label} href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} onClick={closeMenu} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500 last:border-0" data-id="element-203" data-mp="2a4ugzmatc1wi">
              {link.label}
            </a>)}
        </div>}
    </nav>;
}